// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"f5fc8cb2","220":"552089a2","510":"42d46618","594":"df633c76","779":"889f08db","957":"c26f5dfa"}[chunkId] + ".css";
};